import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=6976c530&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6976c530')) {
      api.createRecord('6976c530', component.options)
    } else {
      api.reload('6976c530', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=6976c530&", function () {
      api.rerender('6976c530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KEAhPKIsQmb5/JS/comp/DateRangeExt.vue"
export default component.exports